// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.make-offers-body {
  margin: 0% 20%;
}

.rewards-slide {
  overflow-y: hidden;
  width: 300px;
}

@media only screen and (min-width: 1400px) {
  .rewards-slide {
    justify-content: center;
  }
}
@media only screen and (max-width: 1399px) {
  .rewards-container {
    padding: 0 !important;
    margin: 0 !important;
    left: 0 !important;
  }
}
@media only screen and (max-width: 1199px) {
  .make-offers-body {
    font-size: 23px !important;
  }
}
@media only screen and (max-width: 992px) {
  .make-offers-title {
    margin: 0% 10% !important;
  }
  .make-offers-body {
    margin: 0% 10%;
  }
  .reward-slide-image {
    width: 170px !important;
    height: 170px !important;
  }
}
@media only screen and (max-width: 767px) {
  .make-offers-body {
    font-size: 20px !important;
  }
  .make-offers-title {
    font-size: 40px !important;
    margin: 0% 5% !important;
  }
  .rewards-header {
    font-size: 40px !important;
  }
  .reward-slide-image {
    width: 170px !important;
    height: 170px !important;
  }
}
@media only screen and (max-width: 576px) {
  .make-offers-body {
    font-size: 20px !important;
    padding: 10px;
  }
  .make-offers-title {
    font-size: 30px !important;
  }
  .rewards-header {
    font-size: 30px !important;
  }
  .reward-slide-image {
    width: 130px !important;
    height: 130px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/buy-on-pamo/component/rewards/rewards.scss"],"names":[],"mappings":"AAEA;EACA,cAAA;AADA;;AAIA;EACG,kBAAA;EACA,YAAA;AADH;;AAIA;EACI;IACI,uBAAA;EADN;AACF;AAKA;EACI;IACI,qBAAA;IACA,oBAAA;IACA,kBAAA;EAHN;AACF;AAQE;EACE;IACI,0BAAA;EANN;AACF;AASE;EACE;IACI,yBAAA;EAPN;EASE;IACI,cAAA;EAPN;EAUM;IACI,uBAAA;IACA,wBAAA;EARV;AACF;AAWE;EACE;IACI,0BAAA;EATN;EAYE;IACI,0BAAA;IACA,wBAAA;EAVN;EAaE;IACI,0BAAA;EAXN;EAcE;IACI,uBAAA;IACA,wBAAA;EAZN;AACF;AAeE;EACE;IACI,0BAAA;IACA,aAAA;EAbN;EAgBE;IACI,0BAAA;EAdN;EAiBE;IACI,0BAAA;EAfN;EAkBE;IACI,uBAAA;IACA,wBAAA;EAhBN;AACF","sourcesContent":["\n\n.make-offers-body{\nmargin:0% 20% ;\n}\n\n.rewards-slide{\n   overflow-y: hidden;\n   width:300px;\n}\n\n@media only screen and (min-width: 1400px) {\n    .rewards-slide{\n        justify-content: center;\n    }\n  }\n\n\n@media only screen and (max-width: 1399px) {\n    .rewards-container{\n        padding:0 !important;\n        margin:0 !important;\n        left:0 !important;\n    }\n  }\n\n\n\n  @media only screen and (max-width: 1199px) {\n    .make-offers-body{\n        font-size:23px !important;\n    }\n  }\n\n  @media only screen and (max-width: 992px) {\n    .make-offers-title{\n        margin:0% 10% !important;\n    }\n    .make-offers-body{\n        margin:0% 10% ;\n        }\n\n        .reward-slide-image{\n            width: 170px !important;\n            height: 170px !important;\n        }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .make-offers-body{\n        font-size:20px !important;\n    }\n\n    .make-offers-title {\n        font-size:40px !important;\n        margin:0% 5% !important;\n    }\n\n    .rewards-header{\n        font-size:40px !important;\n    }\n\n    .reward-slide-image{\n        width: 170px !important;\n        height: 170px !important;\n    }\n  }\n\n  @media only screen and (max-width: 576px) {\n    .make-offers-body{\n        font-size:20px !important;\n        padding:10px \n    }\n\n    .make-offers-title {\n        font-size:30px !important;\n    }\n\n    .rewards-header{\n        font-size:30px !important;\n    }\n\n    .reward-slide-image{\n        width: 130px !important;\n        height: 130px !important;\n    }\n\n    // .reward-items{\n    //     margin:8% 2% !important ;\n    // }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
